import { useMRT_TableOptions } from './hooks/useMRT_TableOptions';
import { useMRT_TableInstance } from './hooks/useMRT_TableInstance';
export const useMantineReactTable = (tableOptions) => {
    const parsedTableOptions = useMRT_TableOptions(tableOptions);
    const tableInstance = useMRT_TableInstance(parsedTableOptions);
    return tableInstance;
};
//# sourceMappingURL=useMantineReactTable.js.map